export const NOTIFICATION_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
  PAYMENT: "payment",
  SYSTEM: "system",
};

export const NOTIFICATION_TITLES = {
  payment: "Nuevo Pago",
  system: "Sistema",
  success: "Éxito",
  error: "Error",
  warning: "Advertencia",
  info: "Información",
};
